import ja from './ja';

const resources = {
  ja: {
    translation: ja,
  },
};

export default resources;